import { apiClient } from "@/api/config/api-client.ts";
import { API_ENDPOINTS } from "@/api/config/api-endpoints.ts";
import { queryService } from "@/api/services";
import {
  CheckoutSessionStatusResponse,
  CreateCheckoutSessionResponse,
  User,
} from "@/api/models/api-types.ts";

class StripeService {
  // Yeni checkout session oluştur
  async createCheckoutSession(
    planId: string,
    email: string,
    userId: string
  ): Promise<CreateCheckoutSessionResponse> {
    return queryService.createCheckoutSession(planId, email, userId);
  }

  // Mevcut checkout session'ı kontrol et.
  // Tutar/para birimi/payment_intent de dönüyor: satın alma olayı bu sunucu
  // onaylı değerlerle raporlanıyor, ekrandaki fiyatla değil.
  async getCheckoutSession(
    sessionId: string
  ): Promise<CheckoutSessionStatusResponse> {
    return queryService.getCheckoutSessionStatus(sessionId);
  }

  // Kullanıcı bilgilerini güncelle (/me endpoint'i)
  async refreshUserData(): Promise<{ data: User }> {
    return await apiClient.get<{ data: User }>(API_ENDPOINTS.getMe);
  }
}

export const stripeService = new StripeService();
